import Navbar from '@/components/base/Navbar';
import Footer from '@/components/base/Footer';
import HeroSection from './components/HeroSection';
import HotComics from './components/HotComics';
import LatestUpdates from './components/LatestUpdates';
import CategoryEntry from './components/CategoryEntry';
import EditorPick from './components/EditorPick';
import AboutIntro from './components/AboutIntro';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HotComics />
        <LatestUpdates />
        <CategoryEntry />
        <EditorPick />
        <AboutIntro />
        <FaqSection />
        <CtaSection />
      </main>
      <Footer />
    </>
  );
}